import './style.scss';
import { TranslationService } from '../../../../../services/translation.service';
import type { IJourney } from '../../../../../models/journey.model';
import { JourneyHelper } from '../../../../../helpers/journey.helper';
import type { ITripLeg } from '../../../../../models/trip-leg.model';
import { createWhenString } from '../helpers/summary-helpers';
import LineDescription from '../../../LineDescription';
import { DateTimeHelper } from '../../../../../helpers/date-time.helper';

function Summary({ id, journey, tripLeg, onEditButtonClick }: { id: string; journey: IJourney; tripLeg: ITripLeg; onEditButtonClick?: (() => void) | undefined }) {
  // === VARIABLES ===
  const plannedDepartureTime = JourneyHelper.getFirstPublicTransportLeg(journey)?.plannedDepartureTime;
  const plannedArrivalTime = JourneyHelper.getLastPublicTransportLeg(journey)?.plannedArrivalTime;

  // === RENDERING ===
  return (
    <div className="trip-leg-selector-summary p-2 rounded border">
      <table className="table table-borderless table-sm">
        <caption className="visually-hidden">{TranslationService.get('customerserviceforms.triplegselectorsummarycaption')}</caption>
        <tbody>
          {journey.tripLegs?.length === 1 && (
            <tr>
              <td colSpan={2}>{tripLeg.serviceJourney?.line && <LineDescription line={tripLeg.serviceJourney.line} showTransportMode={true} showDirectionName={true} />}</td>
            </tr>
          )}
          {journey.tripLegs && journey.tripLegs.length > 0 && (
            <>
              <tr>
                <th scope="row">{TranslationService.get('common.from')}:</th>
                <td className="w-100">{journey.tripLegs[0].origin.stopPoint.name}</td>
              </tr>
              <tr>
                <th scope="row">{TranslationService.get('common.to')}:</th>
                <td>{journey.tripLegs[journey.tripLegs.length - 1].destination.stopPoint.name}</td>
              </tr>
            </>
          )}
          <tr>
            <th scope="row">{TranslationService.get('common.when')}:</th>
            <td>
              <span className="text-preserve-spaces">{createWhenString(plannedDepartureTime, plannedArrivalTime)}</span>
            </td>
          </tr>
          {plannedDepartureTime && plannedArrivalTime && (
            <tr>
              <th scope="row">{TranslationService.get('common.traveltime')}:</th>
              <td>{DateTimeHelper.toDuration(plannedDepartureTime, plannedArrivalTime)}</td>
            </tr>
          )}
          {journey.tripLegs && journey.tripLegs.length > 1 && (
            <>
              <tr>
                <td colSpan={2}>
                  <hr className="my-2" />
                </td>
              </tr>
              <tr>
                <th colSpan={2} scope="colgroup">
                  {TranslationService.get('common.tripleg')}:
                </th>
              </tr>
              <tr>
                <td colSpan={2}>{tripLeg.serviceJourney?.line && <LineDescription line={tripLeg.serviceJourney.line} showTransportMode={true} showDirectionName={true} />}</td>
              </tr>
              <tr>
                <th scope="row">{TranslationService.get('common.from')}:</th>
                <td>{tripLeg.origin.stopPoint.name}</td>
              </tr>
              <tr>
                <th scope="row">{TranslationService.get('common.to')}:</th>
                <td>{tripLeg.destination.stopPoint.name}</td>
              </tr>
              <tr>
                <th scope="row">{TranslationService.get('common.when')}:</th>
                <td>
                  <span className="text-preserve-spaces">{createWhenString(tripLeg.plannedDepartureTime, tripLeg.plannedArrivalTime)}</span>
                </td>
              </tr>
            </>
          )}
        </tbody>
      </table>
      <div className="text-end">
        <button className="btn btn-tertiary btn-icon-left btn-icon-pen" aria-controls={`${id}-form`} onClick={onEditButtonClick}>
          {TranslationService.get('common.edit')}
        </button>
      </div>
    </div>
  );
}

export default Summary;
